import * as React from 'react';

import { Button, Typography2 } from '@coursera/cds-core';

import Modal from 'bundles/phoenix/components/Modal';

import _t from 'i18n!nls/git';

type Props = {
  onClose: () => void;
  openInvitationPage: () => void;
};

const PendingInvitationModal = ({ onClose, openInvitationPage }: Props) => (
  <Modal
    className="rc-GitPendingInvitationModal"
    trackingName="git_pending_invitation_modal"
    modalName={_t('Pending Repository Invitation')}
    handleClose={onClose}
  >
    <h2 className="modal-title">{_t('Pending Repository Invitation')}</h2>
    <div>
      <Typography2 component="p" variant="bodyPrimary">
        {_t(
          `You have a pending invitation to this repository. Please click the button below to be taken to a page where
          you can accept this invitation, then return here and launch the repository again.`
        )}
      </Typography2>

      <Button onClick={openInvitationPage}>{_t('Open Invitation')}</Button>
    </div>
  </Modal>
);

export default PendingInvitationModal;
